import '../../../assets/Bullet/bullet.svg.mjs';
import BulletIcon__default from "../../../../../assets/bullet2.svg";
"use strict";
const bullet = {
  id: "bullet",
  title: "bullet.title",
  icon: {
    src: BulletIcon__default,
    width: 51,
    height: 38
  }
};
export { bullet };
//# sourceMappingURL=Bullet.mjs.map
